import * as React from 'react';
import {Link as RoutedLink} from 'react-router-dom';

import classNames from 'classnames';

import {Button} from 'shells/button/button';
import {InlineTextButton} from 'shells/button/inline-text-button/inline-text-button';
import {SlideshowControls} from 'shells/carousel/slideshow-controls';
import {FlashBanner} from 'shells/flash-banner/flash-banner';
import {StackLegacy} from 'shells/layout/stack/stack-legacy';
import {Link} from 'shells/link/link';
import {FooterWithControls, ModalMain} from 'shells/modal/step-modal/layout';
import {Body} from 'shells/typography/body';
import {ModalBody} from 'shells/typography/modal-body';
import {ModalHeader} from 'shells/typography/modal-header';

import {CompetitorsList} from '../competitors-list';

import styles from './add-competitors.module.css';

type Props = {
    competitors: string[];
    onNext: () => void;
    onBack: () => void;
};

export function AddCompetitors(props: Props) {
    const hasFullCompetitorIq = NutClientConfig.hasFullCompetitorIq;

    return (
        <>
            <ModalMain>
                <ModalHeader>Add some competitors</ModalHeader>
                <StackLegacy spacing={8}>
                    {hasFullCompetitorIq ? (
                        <></>
                    ) : (
                        <FlashBanner type='warning' animate={false} hasBorder={true}>
                            <StackLegacy isHorizontal={true} spacing={20} alignCenter={true}>
                                <Body size='normal' color='blue-dk'>
                                    Adding competitors is only available for Marketing Pro
                                    customers.{' '}
                                    <Link
                                        key='upgrade-plan'
                                        // @ts-expect-error
                                        as={RoutedLink}
                                        variant='primary'
                                        size='normal'
                                        to='/setup/billing/sales'
                                        className='underline'
                                    >
                                        Upgrade your plan
                                    </Link>{' '}
                                    to add competitors, or continue without that for now.
                                </Body>
                                <div className={styles['skip-now']}>
                                    <InlineTextButton onClick={props.onNext}>
                                        Skip for now
                                    </InlineTextButton>
                                </div>
                            </StackLegacy>
                        </FlashBanner>
                    )}
                    <ModalBody>
                        <div
                            className={classNames({
                                disabled: !hasFullCompetitorIq,
                            })}
                        >
                            Add or confirm your company’s website to track your online presence and
                            compare it with competitors. If we’ve already detected it, we’ve
                            prefilled the field for your convenience. Just give it a quick
                            confirmation to get started.
                        </div>
                    </ModalBody>
                    <CompetitorsList
                        {...props}
                        isInteractive={hasFullCompetitorIq}
                        isDisabled={!hasFullCompetitorIq}
                    />
                </StackLegacy>
            </ModalMain>
            <FooterWithControls
                controls={<SlideshowControls selectedSlide={1} slideCount={3} />}
                buttons={
                    <>
                        <Button variant='primary' size='big' onClick={props.onBack}>
                            Back
                        </Button>
                        <Button
                            variant='primary'
                            size='big'
                            onClick={props.onNext}
                            disabled={!hasFullCompetitorIq}
                        >
                            Next
                        </Button>
                    </>
                }
            />
        </>
    );
}
